import React, { useContext, useEffect, useRef, useState } from "react";

import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import TransferTicketModal from "../TransferTicketModal";
import ShareTicketModal from "../ShareTicketModal";
import toastError from "../../errors/toastError";
import { Can } from "../Can";
import { AuthContext } from "../../context/Auth/AuthContext";
import PrintIcon from '@material-ui/icons/Print';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { toast } from "react-toastify";

const TicketOptionsMenu = ({ ticket, menuOpen, handleClose, anchorEl }) => {
	const [confirmationOpen, setConfirmationOpen] = useState(false);
	const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
  const [shareTicketModalOpen, setShareTicketModalOpen] = useState(false); 
	const isMounted = useRef(true);
	const { user } = useContext(AuthContext);

	const handlePrint = async () => {
		handleClose();
		const toastId = toast.info("Generando reporte PDF...", { autoClose: false });

		try {
			const { data } = await api.get(`/messages/${ticket.id}`, {
				params: { pageNumber: "all" }
			});
			const messages = data.messages || [];

			const container = document.createElement('div');
			container.style.position = 'absolute';
			container.style.top = '-9999px';
			container.style.left = '0';
			container.style.width = '800px'; 
			container.style.backgroundColor = '#e5ddd5'; 
			container.style.padding = '20px';
			container.style.fontFamily = 'Arial, sans-serif';
			
			let htmlContent = `
				<div style="background: white; padding: 15px; margin-bottom: 20px; border-radius: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
					<h2 style="margin:0 0 5px 0; color: #333;">Reporte de Chat</h2>
					<p style="margin:0; font-size: 14px; color: #666;">Ticket #${ticket.id} - ${ticket.contact.name}</p>
					<p style="margin:0; font-size: 12px; color: #999;">${new Date().toLocaleString()}</p>
				</div>
			`;

			let lastDate = null;

			messages.forEach(msg => {
        if (msg.isNote) return;
				const isMe = msg.fromMe;
				
				const msgDate = new Date(msg.createdAt);
				const dateStr = msgDate.toLocaleDateString();
				if (lastDate !== dateStr) {
					htmlContent += `
						<div style="width: 100%; text-align: center; margin: 15px 0;">
							<span style="background-color: #e1f3fb; color: #555; padding: 5px 10px; border-radius: 10px; font-size: 11px; box-shadow: 0 1px 1px rgba(0,0,0,0.1);">
								${dateStr}
							</span>
						</div>
					`;
					lastDate = dateStr;
				}

        let ackIcon = "";
        if (isMe) {
          const ackColor = (msg.ack === 3 || msg.ack === 4) ? "#34B7F1" : "#999";
          const iconStyle = `width: 14px; height: 14px; vertical-align: middle; fill: ${ackColor};`;
          
          if (msg.ack === 0) {
            ackIcon = `<svg viewBox="0 0 24 24" style="${iconStyle} width: 12px; height: 12px;"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/></svg>`;
          } else if (msg.ack === 1) {
            ackIcon = `<svg viewBox="0 0 24 24" style="${iconStyle}"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>`;
          } else if (msg.ack >= 2) {
            ackIcon = `<svg viewBox="0 0 24 24" style="${iconStyle}"><path d="M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41z M.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z"/></svg>`;
          }
        }

				let mediaHtml = '';
				const fileName = msg.mediaUrl ? msg.mediaUrl.split('/').pop() : "Archivo";

				if (msg.mediaUrl) {
					if (msg.mediaType === 'image') {
						mediaHtml = `
							<div style="margin-bottom: 5px; text-align: center;">
								<img src="${msg.mediaUrl}" crossorigin="anonymous" style="max-width: 250px; max-height: 250px; border-radius: 8px; object-fit: cover;" />
							</div>
						`;
					} else if (msg.mediaType === 'audio') {
						mediaHtml = `
							<div style="display: flex; align-items: center; gap: 8px; background: rgba(0,0,0,0.05); padding: 8px; border-radius: 6px; margin-bottom: 5px;">
								<span style="font-size: 20px;">🎤</span> <span style="font-size: 12px; font-style: italic;">Audio (${fileName})</span>
							</div>
						`;
					} else if (msg.mediaType === 'video') {
						mediaHtml = `
							<div style="display: flex; align-items: center; gap: 8px; background: rgba(0,0,0,0.05); padding: 8px; border-radius: 6px; margin-bottom: 5px;">
								<span style="font-size: 20px;">🎥</span> <span style="font-size: 12px; font-style: italic;">Video (${fileName})</span>
							</div>
						`;
					} else {
						mediaHtml = `
							<div style="display: flex; align-items: center; gap: 10px; background: rgba(0,0,0,0.05); padding: 10px; border-radius: 6px; margin-bottom: 5px; border: 1px solid rgba(0,0,0,0.1);">
								<span style="font-size: 24px;">📄</span> 
								<div style="overflow: hidden;">
									<div style="font-weight: bold; font-size: 12px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 200px;">${fileName}</div>
									<div style="font-size: 10px; color: #777;">${msg.mediaType}</div>
								</div>
							</div>
						`;
					}
				}

				let bodyText = (msg.body || "")
					.replace(/Ø=ÜÅ/g, "•") 
					.replace(/&•þ/g, "•")
					.replace(/Ø=ÜÍ/g, "• Fecha:")
					.replace(/Ø=ÝR/g, "• Hora:")
					.replace(/Ø=Üh/g, "")
					.replace(/\n/g, '<br>');

				if (msg.mediaUrl && bodyText === fileName) {
					bodyText = "";
				}

				bodyText = bodyText.replace(/\*(.*?)\*/g, '<strong>$1</strong>');

				const time = msgDate.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});

				const bubbleStyle = isMe 
					? `background-color: #dcf8c6; float: right; border-radius: 8px 0 8px 8px;` 
					: `background-color: #ffffff; float: left; border-radius: 0 8px 8px 8px;`;

				htmlContent += `
					<div style="width: 100%; overflow: hidden; margin-bottom: 5px;">
						<div style="${bubbleStyle} padding: 6px 10px; max-width: 70%; box-shadow: 0 1px 1px rgba(0,0,0,0.1); position: relative; font-size: 14px; color: #303030;">
							${!isMe ? `<div style="font-size: 12px; color: #e542a3; font-weight: bold; margin-bottom: 4px;">${ticket.contact.name}</div>` : ''}
							
							${mediaHtml} 
							${bodyText ? `<div style="margin-top: ${mediaHtml ? '4px' : '0'}; word-wrap: break-word;">${bodyText}</div>` : ''}
							
							<div style="font-size: 10px; color: #999; margin-top: 4px; display: flex; justify-content: flex-end; align-items: center; gap: 3px;">
                                <span>${time}</span>
                                ${ackIcon ? `<span>${ackIcon}</span>` : ''}
                            </div>
						</div>
					</div>
				`;
			});

			container.innerHTML = htmlContent;
			document.body.appendChild(container);

			const images = Array.from(container.querySelectorAll('img'));
			await Promise.all(images.map(img => {
				if (img.complete) return Promise.resolve();
				return new Promise(resolve => { 
					img.onload = resolve; 
					img.onerror = resolve; 
				});
			}));

			const canvas = await html2canvas(container, {
				scale: 1.5,
				useCORS: true, 
				scrollY: 0,
			});

			document.body.removeChild(container);

			const imgData = canvas.toDataURL('image/png');
			const pdf = new jsPDF('p', 'mm', 'a4');
			const pdfWidth = pdf.internal.pageSize.getWidth();
			const pdfHeight = pdf.internal.pageSize.getHeight();
			
			const imgProps = pdf.getImageProperties(imgData);
			const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;
			
			let heightLeft = imgHeight;
			let position = 0;

			pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
			heightLeft -= pdfHeight;

			while (heightLeft >= 0) {
				position = heightLeft - imgHeight;
				pdf.addPage();
				pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
				heightLeft -= pdfHeight;
			}

			pdf.save(`Chat-${ticket.id}.pdf`);
			toast.dismiss(toastId);
			toast.success("PDF descargado correctamente");

		} catch (err) {
			toast.dismiss(toastId);
			console.error(err);
			toastError(err);
		}
	};
	
	useEffect(() => {
		return () => {
			isMounted.current = false;
		};
	}, []);

  const canManageTicket = user.profile === 'admin' || user.profile === 'superadmin' || user.id === ticket.userId;
  
	const handleDeleteTicket = async () => {
		try {
			await api.delete(`/tickets/${ticket.id}`);
		} catch (err) {
			toastError(err);
		}
	};

	const handleOpenConfirmationModal = e => {
		setConfirmationOpen(true);
		handleClose();
	};

	const handleOpenTransferModal = e => {
		setTransferTicketModalOpen(true);
		handleClose();
	};

	const handleCloseTransferTicketModal = () => {
		if (isMounted.current) {
			setTransferTicketModalOpen(false);
		}
	};

  const handleOpenShareModal = e => {
		setShareTicketModalOpen(true);
		handleClose();
	};

	const handleCloseShareTicketModal = () => {
		if (isMounted.current) {
			setShareTicketModalOpen(false);
		}
	};
  
	return (
		<>
			<Menu
				id="menu-appbar"
				anchorEl={anchorEl}
				getContentAnchorEl={null}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				keepMounted
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
				open={menuOpen}
				onClose={handleClose}
			>
				<MenuItem onClick={handlePrint}>
          <PrintIcon fontSize="small" style={{ marginRight: 10 }} color="action" />
					Imprimir / PDF
				</MenuItem>
				{canManageTicket && (
          <MenuItem onClick={handleOpenTransferModal}>
            {i18n.t("ticketOptionsMenu.transfer")}
          </MenuItem>
        )}
        
        {canManageTicket && (
          <MenuItem onClick={handleOpenShareModal}>
            Compartir
          </MenuItem>
        )}
				<Can
					role={user.profile}
					perform="ticket-options:deleteTicket"
					yes={() => (
						<MenuItem onClick={handleOpenConfirmationModal}>
							{i18n.t("ticketOptionsMenu.delete")}
						</MenuItem>
					)}
				/>
			</Menu>
			<ConfirmationModal
				title={`${i18n.t("ticketOptionsMenu.confirmationModal.title")}${
					ticket.id
				} ${i18n.t("ticketOptionsMenu.confirmationModal.titleFrom")} ${
					ticket?.contact?.name
				}?`}
				open={confirmationOpen}
				onClose={setConfirmationOpen}
				onConfirm={handleDeleteTicket}
			>
				{i18n.t("ticketOptionsMenu.confirmationModal.message")}
			</ConfirmationModal>
			<TransferTicketModal
				modalOpen={transferTicketModalOpen}
				onClose={handleCloseTransferTicketModal}
				ticketid={ticket.id}
				ticketWhatsappId={ticket.whatsappId}
			/>
      <ShareTicketModal
				modalOpen={shareTicketModalOpen}
				onClose={handleCloseShareTicketModal}
				ticketId={ticket.id}
			/>
		</>
	);
};

export default TicketOptionsMenu;
